import { ConfigPort } from './configPort.js';

export { ConfigPort };
